import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.NdtBm.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Code extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "code";
    }
}

export function Code$reflection() {
    return class_type("Corpora.NdtBm.MetadataCategories.Code", void 0, Code, Metadata_StringCategory$reflection());
}

export function Code_$ctor_Z721C83C5(aName) {
    return new Code(aName);
}

export class Name extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "name";
    }
}

export function Name$reflection() {
    return class_type("Corpora.NdtBm.MetadataCategories.Name", void 0, Name, Metadata_StringCategory$reflection());
}

export function Name_$ctor_Z721C83C5(aName) {
    return new Name(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.NdtBm.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

export class Pub extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pub";
    }
}

export function Pub$reflection() {
    return class_type("Corpora.NdtBm.MetadataCategories.Pub", void 0, Pub, Metadata_StringCategory$reflection());
}

export function Pub_$ctor_Z721C83C5(aName) {
    return new Pub(aName);
}

